import { Component, OnInit } from '@angular/core';
import { ModerationService } from 'src/app/services/moderation.service';
import { SelectItem } from 'primeng/api';
import { EncryptionService } from 'src/app/services/encryption.service';

@Component({
  selector: 'app-brouillons',
  templateUrl: './brouillons.component.html',
  styleUrls: ['./brouillons.component.css']
})
export class BrouillonsComponent implements OnInit {
  brouillons : any[] = [];

  brouillonCols : any[] = [
    {field: 'type_ptl', header: 'Type'},
    {field: 'id_complexite', header: 'Complexité'},
    {field: 'num_point_accueil', header: 'Num point d\'accueil'},
    {field: 'etat', header:'Etat'}
  ];

  typeFilter : SelectItem[] = [
    {label : 'INITIALE', value : 'INITIALE' },
    {label : 'R', value : 'R' },
    {label : 'R1', value : 'R1' },
    {label : 'R2', value : 'R2' }
  ];

  complexteFilter : SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];

  constructor(private moderationService : ModerationService,private encryptService:EncryptionService) { }

  ngOnInit(): void {

    this.moderationService.getBrouillon().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        this.brouillons = value["data"];
        console.log(this.brouillons);
      }
    });


  }


  getComplexite(idComplexite: number) {
    switch(idComplexite) {
      case(1) : {
        return 'FAIBLE';
        break;
      }
      case(2) : {
        return 'MOYENNE';
        break;
      }
      case(3) : {
        return 'FORTE';
        break;
      }
    }
  }



  remettreDansLot(idModeration : number, idEtat : number) {
    let user =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let options = {
      moderation : idModeration,
      operateur : user.matricule,
      action : 13,
      etat : idEtat
    };

    this.moderationService.changerEtat(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        this.removeFromModerationList(idModeration);
      }
    });
  }

  /**
   * Les deux fonctions suivantes permettent d'enlever les lignes dans le tableau cq ou moderation
   * @param idModeration 
   */
  removeFromModerationList(idModeration : number){
    let index  = this.brouillons.findIndex(current => current.id_moderation === idModeration);
    this.brouillons = this.brouillons.filter((val, i) =>  i != index);
  }

}
